import axios from "./axios";
import config from '../config/configJS';

// REST API pre synchronizáciu zo zdieľaného disku (/api/networkdrive/*). Admin-only na BE.
const BASE = config.endPoint + '/api/networkdrive';
const JSON_OPTS = {
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  withCredentials: true,
};
const GET_OPTS = { withCredentials: true };

// ── Nastavenia + sync now ──
export function getSettings() {
  return axios.get(`${BASE}/settings`, GET_OPTS).then(r => r.data);
}
export function updateSettings(data) {
  return axios.put(`${BASE}/settings`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function syncNow() {
  return axios.post(`${BASE}/sync-now`, '{}', JSON_OPTS).then(r => r.data);
}
export function syncStop() {
  return axios.post(`${BASE}/sync-stop`, '{}', JSON_OPTS).then(r => r.data);
}
export function getSyncStatus() {
  return axios.get(`${BASE}/sync-status`, GET_OPTS).then(r => r.data);
}

// ── Connections (disky) ──
export function listConnections() {
  return axios.get(`${BASE}/connections`, GET_OPTS).then(r => r.data);
}
export function createConnection(data) {
  return axios.post(`${BASE}/connections`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function updateConnection(id, data) {
  return axios.put(`${BASE}/connections/${id}`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function deleteConnection(id) {
  return axios.delete(`${BASE}/connections/${id}`, GET_OPTS);
}
export function testConnection(id) {
  return axios.post(`${BASE}/connections/${id}/test`, '{}', JSON_OPTS).then(r => r.data);
}

// ── Folder mappings ──
export function listFolders(connId) {
  return axios.get(`${BASE}/connections/${connId}/folders`, GET_OPTS).then(r => r.data);
}
export function createFolder(connId, data) {
  return axios.post(`${BASE}/connections/${connId}/folders`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function updateFolder(id, data) {
  return axios.put(`${BASE}/folders/${id}`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function deleteFolder(id) {
  return axios.delete(`${BASE}/folders/${id}`, GET_OPTS);
}

// ── Live browse (strom) — path = relatívna cesta na disku ('/'), prázdna = koreň ──
// Súbory po stránkach: offset = koľko už je načítaných → { folders, files, filesTotal }
export function browse(connId, path, offset = 0) {
  const params = new URLSearchParams();
  if (path) params.set('path', path);
  if (offset) params.set('offset', String(offset));
  const q = params.toString() ? `?${params}` : '';
  return axios.get(`${BASE}/connections/${connId}/browse${q}`, GET_OPTS).then(r => r.data);
}

// Orientačná veľkosť priečinka vrátane podpriečinkov → { files, bytes, complete } (complete=false = viac ako)
export function folderSize(connId, path) {
  const q = path ? `?path=${encodeURIComponent(path)}` : '';
  return axios.get(`${BASE}/connections/${connId}/size${q}`, GET_OPTS).then(r => r.data);
}
